import { Link } from 'react-router-dom';

export default function TestimonialOne() {
  return (
    <section className="signupBanner">
      <div className="inner">
        {/* logo / tagline */}
        <div className="brand">
          <img src="assets/img/logo/logo2.png" alt="TextLink" />
        </div>

        {/* copy + CTA */}
        <div className="copy">
          <h3>Start Messaging in Minutes</h3>
          <p>
            Try TextLink with <strong>300 free messages</strong>. No credit card. No carrier headaches. Just connect and go.
          </p>
          <Link to="/signup" className="cta">
            Start Free Trial
          </Link>
        </div>
      </div>

      {/* ---------- styles ---------- */}
      <style jsx>{`
        .signupBanner {
          padding: clamp(4rem, 10vh, 6rem) 1.25rem;
          background: linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%);
        }

        .inner {
          max-width: 960px;
          margin: 0 auto;
          background: rgba(255, 255, 255, 0.85);
          border: 1px solid rgba(0, 0, 0, 0.05);
          border-radius: 1.5rem;
          padding: clamp(2rem, 4vw, 3rem);
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 2rem;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
        }

        .brand {
          flex: 0 0 160px;
          text-align: center;
        }
        .brand img {
          width: 56px;
          height: auto;
          margin-bottom: 0.5rem;
        }

        .copy {
          flex: 1 1 300px;
          min-width: 260px;
        }
        .copy h3 {
          font-size: clamp(1.65rem, 2vw + 0.5rem, 2rem);
          font-weight: 700;
          margin: 0 0 1rem;
          color: #1e293b;
        }
        .copy p {
          font-size: clamp(1rem, 0.9vw + 0.8rem, 1.1rem);
          line-height: 1.7;
          color: #475569;
          margin: 0 0 1.5rem;
        }

        .cta {
          display: inline-block;
          background: #3b82f6;
          color: white;
          padding: 0.85rem 2rem;
          border-radius: 9999px;
          font-weight: 600;
          font-size: 1rem;
          text-decoration: none;
          transition: background 0.25s ease, box-shadow 0.25s ease;
          box-shadow: 0 5px 14px rgba(59, 130, 246, 0.3);
        }

        .cta:hover {
          background: #2563eb;
          box-shadow: 0 8px 20px rgba(37, 99, 235, 0.4);
        }

        @media (max-width: 640px) {
          .inner {
            flex-direction: column;
            text-align: center;
          }
          .brand {
            flex: none;
          }
        }
      `}</style>
    </section>
  );
}
